import { Divider, Input, Select } from "antd";
import type { SelectProps } from "antd";
import React, { useEffect, useState, memo } from "react";
import { Button } from "react-bootstrap";

interface CustomDropdownSelectProps extends SelectProps {
  addInputPlaceholder?: string;
  addButtonText?: string;
  addMoreOptions?: boolean;
}

export const CustomDropdownSelect: React.FC<CustomDropdownSelectProps> = memo(
  ({
    options = [],
    addInputPlaceholder = "",
    addButtonText = "Thêm",
    addMoreOptions = true,
    ...restSelectProps
  }) => {
    const [items, setItems] = useState<any[]>(options);
    const [name, setName] = useState("");

    const onNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setName(event.target.value);
    };

    const addItem = (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (!name) return;
      setItems([...items, { label: name.trim(), value: name.trim() }]);
      setName("");
    };

    useEffect(() => {
      setItems(options);
    }, [options]);

    return (
      <Select
        dropdownRender={(menu) => (
          <>
            {menu}
            {addMoreOptions && (
              <>
                <Divider style={{ margin: "8px 0" }} />
                <div
                  className="flex-start"
                  style={{ padding: "0 8px 4px", gap: 5 }}
                >
                  <Input
                    placeholder={addInputPlaceholder}
                    value={name}
                    onChange={onNameChange}
                    style={{ fontWeight: 400 }}
                  />
                  <Button
                    variant="primary"
                    onClick={addItem}
                    style={{ whiteSpace: "nowrap", height: 38 }}
                  >
                    {addButtonText}
                  </Button>
                </div>
              </>
            )}
          </>
        )}
        options={items}
        {...restSelectProps}
      />
    );
  }
);
